import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HttpClient,
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Page Route
import { AppRoutingModule } from './app-routing.module';
import { LayoutsModule } from './layouts/layouts.module';
import { ToastrModule } from 'ngx-toastr';

// Laguage
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Store
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
// component
import { AppComponent } from './app.component';
import { AuthlayoutComponent } from './authlayout/authlayout.component';
import { environment } from 'src/environments/environment';
import { rootReducer } from './store';
import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { AuthenticationEffects } from './store/Authentication/authentication.effects';
import { LayoutEffects } from './store/layouts/layout.effects';
import { NwmlsEffects } from './store/nwmls/nwmls.effect';
import { ApiLoaderComponent } from './core/api-loader/api-loader.component';
import { BlogsEffects } from './store/Blogs/blogs.effect';
import {
  MAT_SNACK_BAR_DEFAULT_OPTIONS,
  MatSnackBarModule,
} from '@angular/material/snack-bar';
import { LeadsEffects } from './store/Leads/leads.effect';
import { SubscribersEffects } from './store/subscribers/subscribers.effect';
import { UsersEffects } from './store/users/users.effect';
import { AgentsEffects } from './store/agents/agents.effect';
import { Aris360Effects } from './store/aris360/aris360.effect';
import { SupportTicketsEffects } from './store/support-tickets/support-tickets.effects';
import { DashboardEffects } from './store/dashboards/dashboard.effect';
import { AgentsRequestsEffects } from './store/agents-requests/agents-requests.effect';
import { ChatEffects } from './store/chats/chats.effect';
import { OffMarketPropertiesEffects } from './store/off-market-properties/off-market-properties.effect';
import { ContactQueriesEffects } from './store/contact-queries/contact-queries.effect';
import { MarketedPropertiesEffects } from './store/marketed-properties/marketed-properties.effect';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
@NgModule({
  declarations: [AppComponent, AuthlayoutComponent, ApiLoaderComponent],
  bootstrap: [AppComponent],
  imports: [
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    StoreModule.forRoot(rootReducer),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    EffectsModule.forRoot([
      AuthenticationEffects,
      LayoutEffects,
      NwmlsEffects,
      BlogsEffects,
      LeadsEffects,
      SubscribersEffects,
      UsersEffects,
      AgentsEffects,
      Aris360Effects,
      SupportTicketsEffects,
      DashboardEffects,
      AgentsRequestsEffects,
      ChatEffects,
      OffMarketPropertiesEffects,
      ContactQueriesEffects,
      MarketedPropertiesEffects,
    ]),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LayoutsModule,
    ToastrModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { duration: 5000, horizontalPosition: 'right' },
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
